/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import DailyClosingSummaryOtaComsnOta from './DailyClosingSummaryOtaComsnOta'

/**
 * The DailyClosingSummaryOtaComsn model module.
 * @module model/DailyClosingSummaryOtaComsn
 * @version 1.0.0
 */
export default class DailyClosingSummaryOtaComsn {
  /**
   * Constructs a new <code>DailyClosingSummaryOtaComsn</code>.
   * @alias module:model/DailyClosingSummaryOtaComsn
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>DailyClosingSummaryOtaComsn</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DailyClosingSummaryOtaComsn} obj Optional instance to populate.
   * @return {module:model/DailyClosingSummaryOtaComsn} The populated <code>DailyClosingSummaryOtaComsn</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DailyClosingSummaryOtaComsn()

      if (data.hasOwnProperty('total')) {
        obj['total'] = ApiClient.convertToType(data['total'], 'Number')
      }
      if (data.hasOwnProperty('ota')) {
        obj['ota'] = ApiClient.convertToType(data['ota'], [DailyClosingSummaryOtaComsnOta])
      }
    }
    return obj
  }

  /**
   * @member {Number} total
   */
  total = undefined
  /**
   * @member {Array.<module:model/DailyClosingSummaryOtaComsnOta>} ota
   */
  ota = undefined
}
